export default __webpack_public_path__ + "static/astronaut-bee-e516ff1169f76dc00cec154a91f8996d.png";